import { render, staticRenderFns } from "./SeletorDeAtributoMarketplace.vue?vue&type=template&id=c7ab8be0&"
import script from "./SeletorDeAtributoMarketplace.vue?vue&type=script&lang=ts&"
export * from "./SeletorDeAtributoMarketplace.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VListItem})
